export default __webpack_public_path__ + "static/media/supplies1.e021fb96.jpg";